/**
 * Tujuh hari yang mengisi papan di halaman depan.
 *
 * Semuanya dihitung dari jam LOKAL pengunjung. Menambah hari lewat `setDate()`
 * menjaga jam dinding tetap sama saat pergantian waktu musim panas, sedangkan
 * `toISOString()` akan menggesernya ke UTC — di WIB (UTC+7) itu berarti tanggal
 * yang ditampilkan menjadi H-1 untuk hampir sepanjang hari.
 */

export interface HariPapan {
  /** Kunci stabil untuk React — `YYYY-MM-DD` waktu lokal, bukan UTC. */
  key: string
  /** Tengah malam waktu lokal pada hari itu. */
  date: Date
  /** Nama hari singkat, mis. "Sen". */
  hari: string
  /** Tanggal, mis. "12". */
  tanggal: string
  /** Bulan singkat, mis. "Okt". */
  bulan: string
  /** Hari yang sedang berjalan. */
  hariIni: boolean
}

const namaHari = new Intl.DateTimeFormat('en-GB', { weekday: 'short' })
const namaBulan = new Intl.DateTimeFormat('en-GB', { month: 'short' })
const angkaTanggal = new Intl.DateTimeFormat('en-GB', { day: 'numeric' })

/** Tanggal lokal sebagai `YYYY-MM-DD` — tanpa pergeseran zona waktu. */
export function kunciLokal(date: Date): string {
  const bulan = String(date.getMonth() + 1).padStart(2, '0')
  const tanggal = String(date.getDate()).padStart(2, '0')
  return `${date.getFullYear()}-${bulan}-${tanggal}`
}

/** Tujuh hari mulai dari `mulai` (default: hari ini), masing-masing satu entri. */
export function papanMinggu(mulai: Date = new Date(), jumlah = 7): HariPapan[] {
  const awal = new Date(mulai.getFullYear(), mulai.getMonth(), mulai.getDate())
  const keyAwal = kunciLokal(awal)

  return Array.from({ length: jumlah }, (_, i) => {
    const date = new Date(awal)
    date.setDate(awal.getDate() + i)
    const key = kunciLokal(date)

    return {
      key,
      date,
      hari: namaHari.format(date),
      tanggal: angkaTanggal.format(date),
      bulan: namaBulan.format(date),
      hariIni: key === keyAwal,
    }
  })
}
